<div class="modal-header text-center">
    <h4 class="modal-title">{{'REM_CRDT_CONF_TEXT' | translate}}</h4>
</div>
<div class="modal-body text-center">{{'REMOVE_CRDT_SURE_CONF_TEXT' | translate}}</div>
<div class="modal-footer d-flex justify-content-center" tabindex="0">
    <button class="btn btn-primary  primary-btn" (click)="populateAccountAndConfirmRemove()">{{'REMOVE_CRDT_CONF_TEXT' |
        translate}}</button>
    <button class="btn btn-primary cta-blue info-btn sec-btn" (click)="cancelAccountRemoval()">{{'CANCEL' | translate}}</button>
</div>